export function ip2long(ip) {
    if (!ip) return 0
    const d = ip.split('.')
    return ((+d[0]) * (1 << 24)) + (+(d[1]) << 16) + ((+d[2]) << 8) + (+d[3])
}

export function long2ip(num) {
    if (!num) return '-'
    return [(num >> 24) & 0xff, (num >> 16) & 0xff, (num >> 8) & 0xff, num & 0xff].join('.')
}